import { type Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingBottom: '17px',
    [theme.breakpoints.down(1100)]: {
      paddingBottom: '10px',
    },
  },
  title: {
    marginTop: '35px',
    marginBottom: '15px',
  },
  dataPointContainer: {
    marginBottom: '25px',
  },
  hidden: {
    height: '45px',
    maskImage:
      'linear-gradient(to bottom, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0))',
  },
  trades: {
    marginLeft: '24px',
  },
}));
